import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Minimizar",
  "use": "Minimizar-usage",
  "viewBox": "0 0 14 3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 3\" id=\"Minimizar\"><path fill-rule=\"evenodd\" d=\"M0 0h14v3H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol